<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>
                <b-breadcrumb-item href="#" active>সন্মান আৰু স্বীকৃতি</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">

          <div id="Fin1">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">সন্মান আৰু স্বীকৃতি</h1>
              </b-col>

           </b-row>


             <div id="">
                 <p class="">
                   <b-img src="../assets/esuvidha_award.jpeg" style="width:75%"/>
                 </p>
             </div>
             <p class="content">
             যি সময়ত ব্যক্তিগত মালিকানাধীন শক্তি উপযোগিতাসমূহে সমগ্ৰ শক্তি খণ্ডত অত্যাধুনিক কাৰিকৰী উদ্ভাৱন কাৰ্যকৰী কৰাৰ ক্ষেত্ৰত অগ্ৰণী ভূমিকা লৈছে,
             আই.এছ.জি.এফ. (ইণ্ডিয়ান স্মাৰ্ট গ্ৰিড ফ'ৰাম)ৰ দ্বাৰা আয়োজিত "ইণ্ডিয়ান স্মাৰ্ট ইউটিলিটি সপ্তাহ ২০২১" অনুষ্ঠানত "কৃত্ৰিম বুদ্ধিমত্তা (এ.আই.)
             সম্বলিত মিটাৰ ৰিদিং সমাধান" প্ৰকল্পটোৰ বাবে "উপযোগিতাৰ দ্বাৰা উদীয়মান প্ৰযুক্তি অৱলম্বন" শাখাত অসম শক্তি বিতৰণ কোম্পানী লিমিটেডক (এপিডিচিএল)
             প্লেটিনাম বঁটা প্ৰদান কৰা হৈছে। ৫ মাৰ্চ, ২০২১ তাৰিখে ৰাষ্ট্ৰীয় ৰাজধানীত আয়োজিত এক অনুষ্ঠানত প্ৰতিষ্ঠানটোৰ হৈ পৰিচালনা সঞ্চালক শ্ৰী ৰাকেশ আগৰৱালাই এই বঁটা গ্ৰহণ কৰে।
              ভাৰত চৰকাৰৰ প্ৰাক্তন শক্তি সচিব শ্ৰী পি উমা শংকৰ, ভাৰত চৰকাৰৰ এম.এন.আৰ.ই.-ৰ প্ৰাক্তন সচিব শ্ৰী ভি সুব্ৰমনিয়াম, ভাৰতীয় এঞ্জেল নেটৱৰ্কৰ সহ-প্ৰতিষ্ঠাপক আৰু
              সভাপতি শ্ৰীমতী পদ্মজা ৰূপৰেল আৰু দিল্লী বিদ্যুৎ নিয়ামক আয়োগৰ প্ৰাক্তন সদস্য শ্ৰীযুত বি.পি. সিঙক লৈ গঠিত এক বিশিষ্ট পেনেলে এই বঁটাৰ বাবে মূল্যাঙ্কন কৰিছিল।
             <br><br>
             এ.পি.ডি.চি.এল.-ৰ উপভোক্তা আধাৰৰ ৮৫% গ্ৰাম্য অঞ্চলত আছে। গ্ৰাম্য গ্ৰাহকৰ সঠিক মিটাৰ ৰিদিং গ্ৰহণ কৰাটো এপিডিচিএলৰ বাবে সদায়
             এক প্ৰত্যাহ্বান হৈ আহিছে। কৃত্ৰিম বুদ্ধিমত্তা সম্বলিত মিটাৰ ৰিদিং সমাধানৰ জৰিয়তে, কৃত্ৰিম বুদ্ধিমত্তা সম্বলিত ই-সুবিধা এপ ব্যৱহাৰ কৰি
             এপিডিচিএল-ৰ মিটাৰ ৰিদাৰসকলে মানুহৰ কোনো হস্তক্ষেপ অবিহনে উপভোক্তাৰ মিটাৰ ৰিদিং গ্ৰহন কৰিবলৈ সক্ষম হয়। ইয়াৰ ফলত সঠিক মিটাৰ
             ৰিদিং সংগ্ৰহ আৰু সঠিক বিলিং হয় আৰু ফলস্বৰূপে বিলিং দক্ষতা বৃদ্ধি হোৱাৰ লগতে এপিডিচিএলৰ এ টি এণ্ড চি লোকচান হ্ৰাস হয়।
                 <br><br>
             এই সমাধান ১ জানুৱাৰী, ২০২১ -ৰ পৰা এপিডিচিএলত কাৰ্যকৰী হৈছে। আশা কৰা হৈছে যে কৃত্ৰিম বুদ্ধিমত্তা সম্বলিত মিটাৰ ৰিদিং সমাধানৰ ৰূপায়ণে এপিডিচিএলৰ বাবে
             এক বিত্তীয় পৰিৱৰ্তন আনিব।

             </p>
          </div>
          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'

export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    }

}
</script>

<style scoped="true">
li{
  padding:0;
}
body{
    overflow-y:hidden;
}
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}
.content{
  text-align: justify;
  line-height: 1.5rem;
  font-size:0.9rem;
}
.cntnt{
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding:10px 30px 10px 30px;
}
table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @font-face {
    font-family: Assamese_Font;
    src: url("../assets/Assamese_font/KirtanUni.ttf");
  }
  div{
      font-family: arial,Assamese_Font;
  }
</style>
